import React from 'react'
import SliderHomeReviews from '../../component/slidercomponent/SliderHomeReviews'

const HomeReviews = () => {
    return (
        <>
            <section className="testimonial-section pt-0 section-bg section-padding fix">
                <div className="container">
                    <div className="testimonial-wrapper">
                        <div className="row g-4 align-items-center">
                            <div className="col-lg-6">
                                <div className="testimonial-item">
                                    <div className="swiper testimonial-slider">
                                        <div className="swiper-wrapper">
                                            <div className="swiper-slide">
                                                <div className="content">
                                                    <div className="icon">
                                                        <img src="assets/img/icon/quate.svg" alt="img" />
                                                    </div>
                                                    <p >
                                                       It is a location where students may focus on their studies without interruptions. To provide high-quality instruction, the school has top-notch facilities. In addition, the school engages the kids in both indoor and outdoor games to promote their overall growth.
                                                    </p>
                                                    <div className="info-content">
                                                        <h3>Mr. Sanjay Kumar</h3>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="swiper-slide">
                                                <div className="content">
                                                    <div className="icon">
                                                        <img src="assets/img/icon/quate.svg" alt="img" />
                                                    </div>
                                                    <p>
                                                        This location is serene and extremely near to nature. You will be a lover of the campus and the vegetation if you visit this location. Everything is amazing, including the gardens and the infrastructure. Additional amenities are also offered, such as a sizable cricket field and courts for badminton and volleyball.
                                                    </p>
                                                    <div className="info-content">
                                                        <h3> Mr. Abhishek Singh</h3>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="swiper-slide">
                                                <div className="content">
                                                    <div className="icon">
                                                        <img src="assets/img/icon/quate.svg" alt="img" />
                                                    </div>
                                                    <p>
                                                        One of Satna's top schools for children Such a lovely and novel setting for children's development. Nothing compares to the rattafication method, which emphasizes concept comprehension. Teachers put in a lot of effort.
                                                    </p>
                                                    <div className="info-content">
                                                        <h3>Mr. Deepak Pandey</h3>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="array-buttons wow fadeInUp" data-wow-delay=".5s">
                                        <button className="array-prev"><i className="fas fa-arrow-left" /></button>
                                        <button className="array-next"><i className="fas fa-arrow-right" /></button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="testimonial-image">
                                    <img src="assets/img/svp/HomeReviews.png" alt="img" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



        </>
    )
}

export default HomeReviews